import {
  HorizontalConnectionPos,
  Overlay,
  OverlayRef,
  PositionStrategy,
  VerticalConnectionPos,
} from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

@Component({
    selector: 'gl-modal-hint',
    templateUrl: './modal-hint.component.html',
    styleUrls: ['./modal-hint.component.scss'],
    standalone: false
})
export class ModalHintComponent implements OnDestroy {
  @ViewChild('cdkPortal', { static: false }) public cdkPortal: TemplateRef<any>;
  @ViewChild('infoIcon', { static: false }) public infoIconEl: ElementRef<HTMLElement>;
  @ViewChild('infoWindow', { static: false }) public infoWindowEl: ElementRef<HTMLElement>;
  @ViewChild('infoWrapper', { static: false }) public infoWrapperEl: ElementRef<HTMLElement>;
  private portal: TemplatePortal;
  private overlayRef: OverlayRef;
  private offset = 20;

  constructor(
    private elRef: ElementRef<HTMLElement>,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
  ) {}

  public ngOnDestroy(): void {
    this.destroyTooltipComponent();
  }

  public open() {
    if (this.overlayRef) {
      return this.destroyTooltipComponent();
    }

    this.overlayRef = this.overlay.create({
      positionStrategy: this.generatePositionStrategy(),
    });
    this.portal = new TemplatePortal(this.cdkPortal, this.viewContainerRef);
    this.overlayRef.attach(this.portal);
    window.setTimeout(() => {
      this.renderer.setStyle(this.infoWindowEl.nativeElement, 'visibility', 'visible');
    });
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    if (this.overlayRef && !this.elRef.nativeElement.contains(event.target as Node)) {
      this.destroyTooltipComponent();
    }
  }

  public destroyTooltipComponent() {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef = undefined;
    }
  }

  private generatePosition(
    originX: HorizontalConnectionPos,
    originY: VerticalConnectionPos,
    overlayX: HorizontalConnectionPos,
    overlayY: VerticalConnectionPos,
  ) {
    return this.overlay
      .position()
      .flexibleConnectedTo(this.elRef)
      .withPositions([
        {
          originX,
          originY,
          overlayX,
          overlayY,
        },
      ])
      .withViewportMargin(10);
  }

  private generatePositionStrategy(): PositionStrategy {
    return this.generatePosition('start', 'top', 'start', 'top')
      .withDefaultOffsetX(-this.offset)
      .withDefaultOffsetY(-this.offset);
  }
}
